import { Link } from "react-router-dom";

export function Logo({ dark = false, className = "" }) {
  return (
    <Link to="/" className={`inline-flex items-center gap-2.5 group ${className}`} data-testid="brand-logo">
      <span className="relative grid h-8 w-8 place-items-center rounded-lg accent-bg">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <circle cx="12" cy="12" r="2.4" fill="#07111F" />
          <circle cx="4" cy="5" r="1.7" fill="#07111F" />
          <circle cx="20" cy="6" r="1.7" fill="#07111F" />
          <circle cx="5" cy="19" r="1.7" fill="#07111F" />
          <circle cx="19" cy="18" r="1.7" fill="#07111F" />
          <path d="M12 12L4 5M12 12l8-6M12 12l-7 7M12 12l7 6" stroke="#07111F" strokeWidth="1.3" strokeLinecap="round" />
        </svg>
      </span>
      <span className={`font-display text-lg font-semibold tracking-tight ${dark ? "text-white" : "text-[#07111F]"}`}>
        SefKam
      </span>
    </Link>
  );
}
